import axios from "axios";

export default {
    state: () => ({
    }),
    mutations: {},
    getters: {},
    actions:{
        loadCountryList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/country", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateCountry(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/country", request,{headers})
                .then((response) => {
                    return response.data;
                })

        },
        createCountry(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/country", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteCountry(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/country/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}